import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { RecipeBook } from "@/components/recipes/RecipeBook";

export default function CookbookPage() {
  return (
    <div className="min-h-screen bg-[#0B0D10]" data-testid="cookbook-page">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-8">
        <Link to="/" className="mb-6 inline-flex items-center gap-1 text-xs text-[#A8A090] hover:text-[#F3EBDD]" data-testid="cookbook-home-link"><ChevronLeft className="h-3.5 w-3.5" />Your universes</Link>
        <RecipeBook basePath="/cookbook" eyebrow="Every universe, plus your own kitchen" title="Cookbook" />
      </div>
    </div>
  );
}
